module.exports = __webpack_public_path__ + "fonts/BradfordLLWeb-Regular.a918caed.woff";